<template>
  <a-modal title='歌曲引用' :visible="visible" width="800px"
           @cancel="handleCancel"
           @ok="handleOk" cancelText='关闭'  >
    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="list"
      :pagination="false"
      :loading="loading">
      <div slot="skillImg" slot-scope="text, record">
        <img style="width: 48px;height: 48px;" preview="封面" :src="record.skillImg"/>
      </div>
              <span slot="action" slot-scope="text, record">
                <a-popconfirm title="确定删除吗?" @confirm="() => deleteData(record)">
                 <a>删除</a>
                </a-popconfirm>
              </span>
    </a-table>

  </a-modal>
</template>

<script>

import {listSkill,delSkill} from '@/api/music/skill'
import { tableMixin } from '@/store/table-mixin'
export default {
  name: 'GraphCategory',
  components: {

  },
  mixins: [tableMixin],
  data() {
    return {
      musicId:null,
      visible:false,
      list: [],
      // 展开的行，受控属性
      expandedRowKeys: [],
      replaceFields: {
        id: "id",
        pid: "pid",
        children: "childList"
      },
      sortParams: {
        field: "sort",
        way: "ASC"
      },
      selectedRowKeys: [],
      selectedRows: [],

      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        categoryName: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [

        {
          title: '名称',
          dataIndex: 'skillName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '封面',
          dataIndex: 'skillImg',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'skillImg'}
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'action' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {

  },
  computed: {},
  watch: {},
  methods: {
    show(record){
      this.visible = true;
      this.musicId = record.id;
      this.queryParam.musicId = record.id;
      console.log(record)
      this.getQuoteList();

    },
    /** 查询引用列表 */
    getQuoteList() {
      this.loading = true
      listSkill(this.queryParam).then(response => {
        this.list = response.data;
        this.total = response.data.total
        this.loading = false
      })
    },

    handleOk(){
      this.visible = false
      this.$emit('ok')
    },
    handleCancel(){
      this.visible = false
      this.$emit('ok')
    },
    deleteData(row){

      this.loading = true
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      let data = []
      this.ids.map(id => data.push({ 'id': id }))
      delSkill(data).then(response => {
        if(response.success == true){
          this.$message.success(
            '删除成功',
            3
          )
        }else{
          this.$message.warn(
            response.message,
            3
          )
        }
        this.loading = false
        this.getQuoteList();
      })
    }
  }
}
</script>
<style lang='less' scoped></style>